module.exports = __webpack_public_path__ + "043a93c680b3d9a7acdb5cf0444e2924.pdf";